export const getTenure = (tenure_day) => {
    if (tenure_day === 1 || tenure_day === '1') {
        return `${tenure_day} month`;
    }
    else {
        return `${tenure_day} months`;
    }
};
